<div class="sub-header pt-250">
  <ul class="f-list c-black">
    <li *ngFor="let customerMenuList of customerMenuLists">
      <a (mouseover)="hideShowMenu(true,customerMenuList?.name,customerMenuList.subCategoriesList)"
        (mouseleave)="showNavBar = false"
        (click)="goToShopAll(customerMenuLists?.name,customerMenuLists.id)">{{customerMenuList?.name}}</a>
    </li>
  </ul>
  <div *ngIf="showNavBar" class="sub-menu-hover pt-3" (mouseover)="showNavBar = true" (mouseleave)="showNavBar = false">
    <div  class="sub-hover-menu mt-0">
      <div class="sub-hover-container">
        <div class="row">
          <div class="col-lg-9">
            <div class="d-flex align-items-start sub-menu-tabs">
              <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <h4>{{selectedCategoryName}}</h4>
                <button class="nav-link" [ngClass]="(selectedSubcategory.id == selectedSubCategory ? 'active' : '')"
                  (click)="subCategoryClick(selectedSubcategory.productList,selectedSubcategory.id)"
                  *ngFor="let selectedSubcategory of selectedSubcategories; let i = index;" id="v-pills-cleasner-tab"
                  data-bs-toggle="pill" data-bs-target="#v-pills-cleasner" type="button" role="tab"
                  aria-controls="v-pills-cleasner" aria-selected="true">{{selectedSubcategory?.name}}</button>
              </div>
              <div class="tab-content" id="v-pills-tabContent">
                <div class="tab-pane fade show active" id="v-pills-cleasner" role="tabpanel"
                  aria-labelledby="v-pills-cleasner-tab">
                  <div class="row">
                    <div class="col-md-4 col-6" *ngFor="let product of selectedProducts">
                      <div class="menu-tab-content" (click)="productClick(product)">
                        <span><img
                            [src]="product.imageList.length > 0 ? product.imageList[0].path : 'assets/images/default-product.png'"
                            alt=" image" /></span>
                        <div class="menu-title">{{product?.name}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-lg-3">
            <div class="sub-menu-image">
              <span><img src="assets/images/sub-menu-image.png" alt="image" /></span>
              <a href="#">shop all skin</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>